import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';
import BranchDto from '@/models/Branches/BranchDto';
import DeskDto from '@/models/Desks/DeskDto';
import EmailTemplateDto from '@/models/EmailTemplates/EmailTemplateDto';
import EntityType from '@/models/Shared/EntityType';

export default class CreateCampaignRequest {
    ownerId = '';
    name = '';
    categoryId = '';
    entityType: EntityType = EntityType.Contact;
    emailTemplateId = '';
    isTest = false;
    testEmailAddresses = '';
    branchId: string;
    deskId: string;
}